// extracted by mini-css-extract-plugin
export default {"pageWrapper":"HasProblemsPage_pageWrapper__9ObLT"};